import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import stateSelector from 'reduxModules/testimonials/selectors'
import { testimonialsDispatchers as dispatchers } from 'reduxModules/testimonials/dispatchers'

import VideoModal from '../VideoModal'

import './styles.css'

function Testimonial({ fullName, position, text, thumbnail, videoUrl }) {
  const [isVideoVisible, setVideoVisible] = useState(false)

  if (!thumbnail || !text || !fullName) return null

  return (
    <>
      <section className="testimonial-card">
        <div className="video-thumbnail">
          <button
            className="play-button"
            type="button"
            aria-label="Play testimonial video"
            onClick={() => setVideoVisible(true)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') setVideoVisible(true)
            }}
          >
            <i className="icon-play" />
          </button>
          <img src={thumbnail} alt="Thumbnail" />
          <div className="testimonial-content">
            <h3>{fullName}</h3>
            <p className="position">{position}</p>
          </div>
        </div>

        <div className="testimonial-quote">
          <p>"{text}"</p>
        </div>
      </section>
      <VideoModal
        close={() => setVideoVisible(false)}
        urlHi={videoUrl?.raw?.high}
        urlLow={videoUrl?.raw?.low}
        subtitles={videoUrl?.subtitles}
        visible={isVideoVisible}
      />
    </>
  )
}

Testimonial.propTypes = {
  fullName: PropTypes.string,
  position: PropTypes.string,
  text: PropTypes.string,
  thumbnail: PropTypes.string,
  videoUrl: PropTypes.shape({
    raw: PropTypes.shape({
      high: PropTypes.string.isRequired,
      low: PropTypes.string.isRequired
    }),
    subtitles: PropTypes.array
  })
}

export default connect(stateSelector, dispatchers)(Testimonial)
